import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  CreditHistoryItem,
  CreditHistoryState,
  CreditHistoryUiState,
  TopupCreditHistoryItem,
} from "../types/creditsTypes";

const initialState: CreditHistoryState = {
  history: [],
  topupCreditHistory: [],
  totalCount: 0,
  loading: false,
  error: null,
  ui: {
    sortCriteria: "",
    searchInput: "",
    currentPage: 1,
    scrollY: 0,
  },
};

const creditsSlice = createSlice({
  name: "credits",
  initialState,
  reducers: {
    // Define a reducer and automatically generate its action
    setCreditHistory(
      state: CreditHistoryState,
      action: PayloadAction<{ history: CreditHistoryItem[]; totalCount: number }>
    ) {
      state.history = action.payload.history;
      state.totalCount = action.payload.totalCount;
    },
    setCreditHistoryLoading: (
      state: CreditHistoryState,
      action: PayloadAction<boolean>
    ) => {
      state.loading = action.payload;
    },
    setCreditHistoryError: (
      state: CreditHistoryState,
      action: PayloadAction<string | null>
    ) => {
      state.error = action.payload;
    },
    /** Merge persisted UI state (filters / sort / page / scroll) for back-navigation restore */
    setCreditHistoryUi: (
      state: CreditHistoryState,
      action: PayloadAction<Partial<CreditHistoryUiState>>
    ) => {
      state.ui = { ...state.ui, ...action.payload };
    },
    setTopupCreditHistory: (
      state: CreditHistoryState,
      action: PayloadAction<TopupCreditHistoryItem[]>
    ) => {
      state.topupCreditHistory = action.payload;
    },
    setTopupCreditHistoryLoading: (
      state: CreditHistoryState,
      action: PayloadAction<boolean>
    ) => {
      state.loading = action.payload;
    },
    setTopupCreditHistoryError: (
      state: CreditHistoryState,
      action: PayloadAction<string>
    ) => {
      state.error = action.payload;
    },
  },
});

// Export the automatically generated action creators
export const {
  setCreditHistory,
  setCreditHistoryLoading,
  setCreditHistoryError,
  setCreditHistoryUi,
  setTopupCreditHistory,
  setTopupCreditHistoryError,
  setTopupCreditHistoryLoading
} = creditsSlice.actions;

// Export the reducer
export default creditsSlice.reducer;
